import { create } from 'zustand';

export type ConnState = 'none' | 'connecting' | 'connected' | 'reconnecting' | 'error';
export type HubRole = 'trainer' | 'hr' | 'power' | 'click';

export interface DeviceStatus {
  state: ConnState;
  name?: string;
  kind?: string;
  battery?: number | null;
  error?: string;
  simulated?: boolean;
  caps?: { erg: boolean; sim: boolean; powerRange?: [number, number] };
  /** Reconnect attempt counter while reconnecting. */
  attempt?: number;
  /** Device id (for remembered-device reconnect). */
  id?: string;
}

export interface LiveData {
  t: number;
  powerW: number;
  cadenceRpm: number;
  hrBpm: number;
  /** Trainer-reported speed (not used for game physics). */
  speedKmh: number;
}

interface DevicesState {
  trainer: DeviceStatus;
  hr: DeviceStatus;
  power: DeviceStatus;
  click: DeviceStatus;
  live: LiveData;
  setStatus: (role: HubRole, patch: Partial<DeviceStatus>) => void;
  setLive: (live: LiveData) => void;
}

const none: DeviceStatus = { state: 'none' };

export const useDevices = create<DevicesState>((set) => ({
  trainer: none,
  hr: none,
  power: none,
  click: none,
  live: { t: 0, powerW: 0, cadenceRpm: 0, hrBpm: 0, speedKmh: 0 },
  setStatus: (role, patch) =>
    set(
      (s) =>
        ({
          [role]: patch.state === 'none' ? { state: 'none' } : { ...s[role], ...patch },
        }) as Partial<DevicesState>,
    ),
  setLive: (live) => set({ live }),
}));
